/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Inject, OnInit} from '@angular/core';
import {BsModalRef} from 'ngx-bootstrap/modal';
import * as _ from 'lodash';

import template from './library-creative-copy-modal.component.html';
import {nextCopyTitle} from '../../components/util/next-copy-title';
import {Uuid} from '../../components/util/uuid';
import {LibraryCreativeResource} from '../../components/api/resources/resource/library-creative.resource';
import {AdnModalLoadingService} from '../common/util/adn-modal-loading.service';

export interface LibraryCreativeCopyModalResult {
  destination: boolean;
  creativeId: string;
}

@Component({
  standalone: false,
  selector: 'adn-library-creative-copy-modal',
  template
})
export class LibraryCreativeCopyModalComponent implements OnInit {
  model: any;
  onComplete: (result: LibraryCreativeCopyModalResult) => void;

  sourceName = '';
  name = '';
  destination = true;
  disabled = false;
  validationErrors: any[] = [];

  private creative: any;

  constructor(
    public bsModalRef: BsModalRef,
    @Inject(LibraryCreativeResource) private readonly LibraryCreative: any,
    @Inject(AdnModalLoadingService) private readonly adnModalLoading: any
  ) {
  }

  ngOnInit(): void {
    this.creative = _.cloneDeep(this.model);
    this.sourceName = this.model?.name || '';
    this.name = nextCopyTitle(this.sourceName);
  }

  dismiss(): void {
    this.bsModalRef.hide();
  }

  copyCreative(): void {
    this.disabled = true;
    this.validationErrors = [];
    this.adnModalLoading.applyModalLoading();

    const payload = {
      ...this.creative,
      name: this.name
    };
    const newId = Uuid.generate();

    this.LibraryCreative.copyCreative(payload, payload.lineItem, newId, payload.userState).then(() => {
      this.adnModalLoading.removeModalLoading();
      this.onComplete?.({destination: this.destination, creativeId: newId});
      this.bsModalRef.hide();
    }, (errors: any) => {
      this.disabled = false;
      this.validationErrors = _.get(errors, ['data', 'errors'], []);
      this.adnModalLoading.removeModalLoading();
    });
  }
}
